import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Space, Table, Menu, Image } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import baseRequest from "../../utils/baseRequest";

const VerificationContent = (props) => {
  const { TextArea } = Input;
  const current = props.current;
  //表头
  const columns = [
    {
      title: "基本信息",
      dataIndex: "baseInfo",
      key: "baseInfo",
      render: (data) => (
        <div>
          <Image src={data.avatar} width={50} />
          <p>
            昵称：<span className="text-red-400">{data.name}</span>
          </p>
          <p>
            ID：<span className="text-red-400">{data.user_id}</span>
          </p>
        </div>
      ),
    },
    {
      title: "实名验证信息",
      dataIndex: "verificationInfo",
      key: "verificationInfo",
      render: (data) => (
        <div>
          <p>
            真实姓名：<span className="text-red-400">{data.real_name}</span>
          </p>
          <p>
            身份证号：<span className="text-red-400">{data.ID_no}</span>
          </p>
        </div>
      ),
    },
    {
      title: "身份证照片",
      dataIndex: "ID_card_photos",
      key: "ID_card_photos",
      render: (data) => (
        <div>
          <Image.PreviewGroup items={data?.map((item) => item.urls[0])}>
            {data.map((item) => (
              <Image
                key={item.urls[0]}
                src={item.urls[0]}
                width={100}
                style={{ marginBottom: 10 }}
              />
            ))}
          </Image.PreviewGroup>
        </div>
      ),
    },
    {
      title: "手持身份证照片",
      dataIndex: "full_face_photo_with_ID_card_in_hand",
      key: "full_face_photo_with_ID_card_in_hand",
      render: (data) => <Image src={data} width={100} />,
    },
    {
      title: "提交时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
      render: (_, record) => (
        <Form.Item name={record.id} initialValue={record.remarks}>
          <TextArea rows={4} />
        </Form.Item>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            <Space.Compact direction="vertical">
              {current === "pending" && (
                <Button type="primary" onClick={() => onClickSubmit(record)}>
                  {current === "pending" && "通过"}
                </Button>
              )}
              {current !== "notQualified" && current !== "settled" && (
                <Button onClick={() => onClickNotQualified(record)}>
                  拒绝
                </Button>
              )}
            </Space.Compact>
          </Space>
        </div>
      ),
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //点击修改状态按钮
  const onClickSubmit = (record) => {
    formRef.current.id = record.id;
    formRef.current.btn = "submit";
    formRef.current.submit();
  };
  //点击未符合按钮
  const onClickNotQualified = (record) => {
    formRef.current.id = record.id;
    formRef.current.btn = "notQualified";
    formRef.current.submit();
  };
  //提交表单
  const handleSubmit = async (value) => {
    //要提交的数据
    let approve_status;
    if (formRef.current.btn === "notQualified") {
      approve_status = -1;
    } else {
      switch (current) {
        case "pending":
          approve_status = 0;
          break;
        default:
          break;
      }
    }
    const submitData = {
      ids: [formRef.current.id],
      remarks: value[formRef.current.id] ? value[formRef.current.id] : "",
      approve_status: approve_status,
    };
    //提交数据
    try {
      const base = baseRequest();
      const response = await fetch("/op/realname_authentication/approve", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...submitData,
          ...base,
        }),
      });
      const approveData = await response.json();
      if (approveData.ret === -1) {
        alert(approveData.msg);
        return;
      }
    } catch (error) {
      console.error(error);
    }
    //取消数据展示
    setShowData(showData.filter((item) => item.id !== submitData.ids[0]));
  };
  //获取数据
  const [data, setData] = useState([]);
  const getData = async (user_id) => {
    let querryStatus;
    switch (current) {
      case "pending":
        querryStatus = 1;
        break;
      case "settled":
        querryStatus = 0;
        break;
      case "notQualified":
        querryStatus = -1;
        break;
      default:
        break;
    }
    try {
      const base = baseRequest();
      const response = await fetch("/op/realname_authentication/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: querryStatus,
          offset: 0,
          limit: 100,
          user_id,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      //获取达人头像、昵称
      const streamerMids = temData.data.list.map((item) => item.mid);
      if (streamerMids.length === 0) {
        setData([]);
        return;
      }
      const streamerResponse = await fetch("/op/account/list_others_by_mids", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mids: streamerMids,
          offset: 0,
          limit: 100,
          ...base,
        }),
      });
      const streamerData = await streamerResponse.json();
      if (streamerData.ret === -1) {
        alert(streamerData.msg);
        return;
      }
      //合并认证资料和达人资料数组
      const combinedArray = temData.data.list.map((item1) => {
        const matchingItem = streamerData.data.list.find(
          (item2) => item2.mid === item1.mid
        );
        return { ...item1, ...matchingItem };
      });
      //匹配表格格式
      const structedData = combinedArray.map((item, index) => {
        return {
          key: index,
          id: item.id,
          baseInfo: {
            avatar: item.avatar?.images[0]?.urls[0],
            user_id: item.user_id,
            name: item.name,
          },
          verificationInfo: {
            real_name: item.real_name,
            ID_no: item.ID_no,
          },
          ID_card_photos: item.ID_card_photos.images,
          full_face_photo_with_ID_card_in_hand:
            item.full_face_photo_with_ID_card_in_hand.images[0].urls[0],
          submitTime: new Date(item.ct * 1000).toLocaleString(),
          remarks: item.remarks,
          status: item.status,
        };
      });
      setData([...structedData]);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData();
  }, [current]);

  //展示的数据
  const [showData, setShowData] = useState([]);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //搜索名人
  const search = (value) => {
    if (value.id) {
      setData([]);
      getData(parseInt(value.id));
    } else {
      setData([]);
      getData();
    }
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <p>
        {current === "pending" && `待处理${showData.length}条`}
        {current === "settled" && `已通过${showData.length}条`}
        {current === "notQualified" && `已拒绝${showData.length}条`}
      </p>
      <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
        <Space style={{ marginBottom: 20 }}>
          <Form.Item label="达人ID" name="id" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <p className="text-sm text-red-400">仅显示最新100条</p>
      <Form
        ref={formRef}
        name="remarks"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
    </div>
  );
};

export default function StreamerVerification() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "pending";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "待处理",
      key: "pending",
    },
    {
      label: "已通过",
      key: "settled",
    },
    // {
    //   label: "已拒绝",
    //   key: "notQualified",
    // },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    window.location.reload();
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/streamerVerification/pending" />}
        />
        <Route
          path="/pending"
          element={<VerificationContent current="pending" />}
        />
        <Route
          path="/settled"
          element={<VerificationContent current="settled" />}
        />
        {/* <Route
          path="/notQualified"
          element={<VerificationContent current="notQualified" />}
        /> */}
      </Routes>
    </div>
  );
}
